import { useState } from 'react';
import { validatorFactory } from './validatorFactory';
import { validState } from './utils';
export const useValidator = (hasError, errorMessage, isSuccessful, successMessage, customErrorMessages, helpMessage, required, label) => {
  const [validationState, setValidationState] = useState(validState);
  return {
    validationState,
    validator: validatorFactory(setValidationState, hasError, errorMessage, isSuccessful, successMessage, customErrorMessages, helpMessage, required, label)
  };
};